export * from "./auths";
export * from "./studens";
export * from "./evaluations";
export * from "./courses";
export * from "./weathers";
export * from "./systems";
export * from "./uni_msgs";
export * from "./vpopups";
export * from "./menus";
